import type {ReactNode} from 'react'

import styles from './ContentWrapper.module.css'

export function ContentWrapper({children}: {children: ReactNode}) {
  return <div className={styles.contentContainer}>{children}</div>
}
